import { RoutesConfig } from '../../../config/router/router';
import LazyLoad from '../../../core/common/LazyLoading/LazyLoading';
import { routes } from '../../../config/routes/routes';
import NotFoundPage from '../../../core/pages/error/NotFoundPage/NotFoundPage';
import React from 'react';
import { useLocation } from 'react-router-dom';

/* eslint-disable new-cap */
const EmployeesPage = LazyLoad(
  () => import('../../../erp/pages/admin/Employee/EmployeesPage/EmployeesPage'),
);
const EmployeeViewPage = LazyLoad(
  () => import('../../pages/admin/Employee/EmployeeViewPage/EmployeeViewPage'),
);
const EmployeeVersionPage = LazyLoad(
  () =>
    import(
      '../../../erp/pages/admin/Employee/EmployeeVersionPage/EmployeeVersionPage'
    ),
);

const DocumentsPage = LazyLoad(
  () => import('../../../erp/pages/admin/Document/DocumentsPage/DocumentsPage'),
);
const EmployeeDocumentsPage = LazyLoad(
  () =>
    import(
      '../../../erp/pages/admin/Document/EmployeeDocumentsPage/EmployeeDocumentsPage'
    ),
);

const DocumentTemplateCreatePage = LazyLoad(
  () =>
    import(
      '../../../erp/pages/admin/DocumentTemplate/DocumentTemplateCreatePage/DocumentTemplateCreatePage'
    ),
);
const DocumentTemplateEditPage = LazyLoad(
  () =>
    import(
      '../../../erp/pages/admin/DocumentTemplate/DocumentTemplateEditPage/DocumentTemplateEditPage'
    ),
);

const JobTitlesPage = LazyLoad(
  () => import('../../../erp/pages/admin/JobTitle/JobTitlesPage/JobTitlesPage'),
);
const JobTitleCreatePage = LazyLoad(
  () =>
    import(
      '../../../erp/pages/admin/JobTitle/JobTitleCreatePage/JobTitleCreatePage'
    ),
);
const JobTitleEditPage = LazyLoad(
  () =>
    import(
      '../../../erp/pages/admin/JobTitle/JobTitleEditPage/JobTitleEditPage'
    ),
);

const DepartmentsPage = LazyLoad(
  () =>
    import(
      '../../../erp/pages/admin/Department/DepartmentsPage/DepartmentsPage'
    ),
);
const DepartmentCreatePage = LazyLoad(
  () =>
    import(
      '../../../erp/pages/admin/Department/DepartmentCreatePage/DepartmentCreatePage'
    ),
);
const DepartmentEditPage = LazyLoad(
  () =>
    import(
      '../../../erp/pages/admin/Department/DepartmentEditPage/DepartmentEditPage'
    ),
);

const TasksPage = LazyLoad(
  () => import('../../../erp/pages/admin/Task/TasksPage/TasksPage'),
);
const TaskPage = LazyLoad(
  () => import('../../../erp/pages/admin/Task/TaskPage/TaskPage'),
);

const TimeOffsAvailabilityPage = LazyLoad(
  () => import('../../pages/admin/WorkTime/WorkTimesPage/./WorkTimesPage'),
);
const EmployeeTimeOffsAvailabilityPage = LazyLoad(
  () =>
    import(
      '../../pages/admin/WorkTime/EmployeeWorkTimesPage/./EmployeeWorkTimesPage'
    ),
);

const GlobalDocumentTemplatesPage = LazyLoad(
  () =>
    import(
      '../../../erp/pages/admin/GlobalDocumentTemplate/GlobalDocumentTemplatesPage/GlobalDocumentTemplatesPage'
    ),
);
const GlobalDocumentTemplateCreatePage = LazyLoad(
  () =>
    import(
      // eslint-disable-next-line max-len
      '../../../erp/pages/admin/GlobalDocumentTemplate/GlobalDocumentTemplateCreatePage/GlobalDocumentTemplateCreatePage'
    ),
);
const GlobalDocumentTemplateEditPage = LazyLoad(
  () =>
    import(
      '../../../erp/pages/admin/GlobalDocumentTemplate/GlobalDocumentTemplateEditPage/GlobalDocumentTemplateEditPage'
    ),
);

const GlobalProcessSettingsPage = LazyLoad(
  () =>
    import(
      '../../../erp/pages/admin/GlobalProcessSettings/GlobalProcessSettingsPage/GlobalProcessSettingsPage'
    ),
);
const GlobalProcessSettingsCreatePage = LazyLoad(
  () =>
    import(
      // eslint-disable-next-line max-len
      '../../../erp/pages/admin/GlobalProcessSettings/GlobalProcessSettingsCreatePage/GlobalProcessSettingsCreatePage'
    ),
);
const GlobalProcessSettingsEditPage = LazyLoad(
  () =>
    import(
      '../../../erp/pages/admin/GlobalProcessSettings/GlobalProcessSettingsEditPage/GlobalProcessSettingsEditPage'
    ),
);
const ProcessSettingsCreatePage = LazyLoad(
  () =>
    import(
      // eslint-disable-next-line max-len
      '../../../erp/pages/admin/ProcessSettings/ProcessSettingsCreatePage/ProcessSettingsCreatePage'
    ),
);
const ProcessSettingsEditPage = LazyLoad(
  () =>
    import(
      '../../../erp/pages/admin/ProcessSettings/ProcessSettingsEditPage/ProcessSettingsEditPage'
    ),
);

const ProcessesPage = LazyLoad(
  () => import('../../../erp/pages/admin/Process/ProcessesPage/ProcessesPage'),
);
const ProcessesByEmployeePage = LazyLoad(
  () =>
    import(
      '../../../erp/pages/admin/Process/ProcessesByEmployeePage/ProcessesByEmployeePage'
    ),
);
const ProcessViewPage = LazyLoad(
  () =>
    import('../../../erp/pages/admin/Process/ProcessViewPage/ProcessViewPage'),
);
const EmployeeProfile = LazyLoad(
  () =>
    import(
      '../../../erp/pages/admin/Employee/EmployeeProfilePage/EmployeeProfilePage'
    ),
);

const DocumentsRoute = () => {
  const location = useLocation();
  return <DocumentsPage key={location.pathname} />;
};

const EmployeeDocumentsRoute = () => {
  const location = useLocation();
  return <EmployeeDocumentsPage key={location.pathname} />;
};

export const ERP_ROUTER_CONFIG: RoutesConfig = {
  auth: [],
  authNonAuth: [],
  admin: [
    {
      path: routes.admin.employees.list,
      element: <EmployeesPage />,
    },
    {
      path: routes.admin.employees.view,
      element: <EmployeeViewPage />,
    },
    {
      path: routes.admin.employees.version,
      element: <EmployeeVersionPage />,
    },
    {
      path: routes.admin.documents.list,
      element: <DocumentsRoute />,
    },
    {
      path: routes.admin.documents.folder,
      element: <DocumentsRoute />,
    },
    {
      path: routes.admin.documents.listForEmployee,
      element: <EmployeeDocumentsRoute />,
    },
    {
      path: routes.admin.documents.folderForEmployee,
      element: <EmployeeDocumentsRoute />,
    },
    {
      path: routes.admin.documentTemplates.new,
      element: <DocumentTemplateCreatePage />,
    },
    {
      path: routes.admin.documentTemplates.edit,
      element: <DocumentTemplateEditPage />,
    },
    {
      path: routes.admin.jobTitles.list,
      element: <JobTitlesPage />,
    },
    {
      path: routes.admin.jobTitles.new,
      element: <JobTitleCreatePage />,
    },
    {
      path: routes.admin.jobTitles.edit,
      element: <JobTitleEditPage />,
    },
    {
      path: routes.admin.departments.list,
      element: <DepartmentsPage />,
    },
    {
      path: routes.admin.departments.new,
      element: <DepartmentCreatePage />,
    },
    {
      path: routes.admin.departments.edit,
      element: <DepartmentEditPage />,
    },
    {
      path: routes.admin.tasks.list,
      element: <TasksPage />,
    },
    {
      path: routes.admin.tasks.view,
      element: <TaskPage />,
    },
    {
      path: routes.admin.workTimes.schedule,
      element: <TimeOffsAvailabilityPage />,
    },
    {
      path: routes.admin.workTimes.scheduleForEmployee,
      element: <EmployeeTimeOffsAvailabilityPage />,
    },
    {
      path: routes.admin.globalDocumentTemplates.list,
      element: <GlobalDocumentTemplatesPage />,
    },
    {
      path: routes.admin.globalDocumentTemplates.new,
      element: <GlobalDocumentTemplateCreatePage />,
    },
    {
      path: routes.admin.globalDocumentTemplates.edit,
      element: <GlobalDocumentTemplateEditPage />,
    },
    {
      path: routes.admin.globalProcessSettings.list,
      element: <GlobalProcessSettingsPage />,
    },
    {
      path: routes.admin.globalProcessSettings.new,
      element: <GlobalProcessSettingsCreatePage />,
    },
    {
      path: routes.admin.globalProcessSettings.edit,
      element: <GlobalProcessSettingsEditPage />,
    },
    {
      path: routes.admin.processSettings.new,
      element: <ProcessSettingsCreatePage />,
    },
    {
      path: routes.admin.processSettings.edit,
      element: <ProcessSettingsEditPage />,
    },
    {
      path: routes.admin.processes.list,
      element: <ProcessesPage />,
    },
    {
      path: routes.admin.processes.listByEmployee,
      element: <ProcessesByEmployeePage />,
    },
    {
      path: routes.admin.processes.view,
      element: <ProcessViewPage />,
    },
    {
      path: routes.admin.employees.employeeProfile,
      element: <EmployeeProfile />,
    },
    {
      path: '*',
      element: <NotFoundPage />,
    },
  ],
  adminNonAuth: [],
};
